import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockCards {
    constructor() {
        this.blocks = document.querySelectorAll(".block-cards");

        if (this.blocks && this.blocks.length > 0) {
            this.cardTextHeight();
            this.cardArrows();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    cardTextHeight() {
        this.blocks.forEach(block => {
            const cards = block.querySelectorAll(".item-card");
            cards.forEach(card => {
                const cardText = card.querySelector(".rich-text");
                const cardTextHeight = cardText.offsetHeight;
                card.style.setProperty('--height', cardTextHeight + 'px');
            });
        });
    }

    cardArrows() {
        this.blocks.forEach(block => {
            const cards = block.querySelectorAll(".no-touchevents .item-card");
            cards.forEach((card) => {
                const arrow = card.querySelector(".arrow");

                if (arrow) {
                    // Configuration de base pour les animations
                    const btnConfig = {duration: 0.45, ease: "power2.out"};

                    // Création des fonctions quickTo avec des configurations distinctes
                    const moveBtnPosition = {
                        top: gsap.quickTo(arrow, "top", btnConfig),
                        left: gsap.quickTo(arrow, "left", btnConfig)
                    };

                    // Animations standards pour les autres propriétés
                    card.addEventListener("mouseenter", (e) => {
                        const blockOffset = card.getBoundingClientRect();

                        // Animation de l'apparition
                        gsap.to(arrow, {
                            opacity: 1,
                            duration: 0.3
                        });

                        // Positionnement initial
                        moveBtnPosition.top(e.clientY - blockOffset.top);
                        moveBtnPosition.left(e.clientX - blockOffset.left);
                    });

                    card.addEventListener("mousemove", (e) => {
                        const blockOffset = card.getBoundingClientRect();
                        moveBtnPosition.top(e.clientY - blockOffset.top);
                        moveBtnPosition.left(e.clientX - blockOffset.left);
                    });

                    card.addEventListener("mouseleave", () => {
                        gsap.to(arrow, {
                            opacity: 0,
                            duration: 0.3
                        });
                    });
                }
            });
        });
    }

    resize() {
        this.cardTextHeight();
    }
}

// import { GlobalVariables } from "../GlobalVariables";
// import { gsap } from "../LibrariesImport"; // ScrollTrigger est enregistré globalement si besoin
//
// export default class BlockCards {
//     constructor() {
//         this.blocks = Array.from(document.querySelectorAll(".block-cards"));
//         // On garde des références pour cleanup si un jour tu ajoutes destroy()
//         this.state = new Map(); // block -> { ctx, mmReverts: [], listeners: [() => void] }
//
//         if (this.blocks.length) {
//             this.blocks.forEach((block) => this.mountBlock(block));
//             this.cardTextHeight();
//             GlobalVariables.resizeCallbacks.push(this);
//         }
//     }
//
//     // ===== Mount / Unmount par block =====
//     mountBlock(block) {
//         // On collecte ici puis on écrira dans this.state après le context()
//         const collected = {
//             mmReverts: [],
//             listeners: [],
//             cards: []
//         };
//
//         const ctx = gsap.context(() => {
//             const cards = Array.from(block.querySelectorAll(".item-card"));
//             collected.cards = cards;
//
//             // --- REVEAL AU SCROLL (desktop seulement) ---
//             const mm = gsap.matchMedia();
//             collected.mmReverts.push(
//                 mm.add("(min-width: 991px)", () => {
//                     cards.forEach((card, index) => {
//                         const yOffset = 200 + index * 100;
//                         gsap.fromTo(
//                             card,
//                             { opacity: 0, y: yOffset },
//                             {
//                                 opacity: 1,
//                                 y: 0,
//                                 ease: "power2.out",
//                                 scrollTrigger: {
//                                     trigger: block,
//                                     start: "top bottom",
//                                     end: "center center",
//                                     scrub: true,
//                                 },
//                             }
//                         );
//                     });
//                 })
//             );
//
//             // --- FLECHE QUI SUIT LE CURSEUR ---
//             cards.forEach((card) => {
//                 const arrow = card.querySelector(".arrow");
//                 if (!arrow) return;
//
//                 const btnConfig = { duration: 0.45, ease: "power2.out" };
//                 const moveBtnTop = gsap.quickTo(arrow, "top", btnConfig);
//                 const moveBtnLeft = gsap.quickTo(arrow, "left", btnConfig);
//
//                 const onEnter = (e) => {
//                     const box = card.getBoundingClientRect();
//                     gsap.to(arrow, { opacity: 1, duration: 0.3 });
//                     const { clientX, clientY } = e.type.startsWith("pointer")
//                         ? e
//                         : e.touches?.[0] || {};
//                     if (clientX != null) {
//                         moveBtnTop(clientY - box.top);
//                         moveBtnLeft(clientX - box.left);
//                     }
//                 };
//
//                 const onMove = (e) => {
//                     const box = card.getBoundingClientRect();
//                     const { clientX, clientY } = e.type.startsWith("pointer")
//                         ? e
//                         : e.touches?.[0] || {};
//                     if (clientX != null) {
//                         moveBtnTop(clientY - box.top);
//                         moveBtnLeft(clientX - box.left);
//                     }
//                 };
//
//                 const onLeave = () => {
//                     gsap.to(arrow, { opacity: 0, duration: 0.3 });
//                 };
//
//                 card.addEventListener("pointerenter", onEnter);
//                 card.addEventListener("pointermove", onMove);
//                 card.addEventListener("pointerleave", onLeave);
//
//                 // cleanup à stocker
//                 collected.listeners.push(() => {
//                     card.removeEventListener("pointerenter", onEnter);
//                     card.removeEventListener("pointermove", onMove);
//                     card.removeEventListener("pointerleave", onLeave);
//                 });
//             });
//         }, block); // <<< exécute la callback tout de suite
//
//         // >>> Maintenant seulement, ctx est initialisé : on peut setter l'état
//         this.state.set(block, {
//             ctx,
//             mmReverts: collected.mmReverts,
//             listeners: collected.listeners,
//             cards: collected.cards,
//         });
//     }
//
//     unmountBlock(block) {
//         const st = this.state.get(block);
//         if (!st) return;
//         // kill listeners
//         st.listeners?.forEach((off) => off());
//         // revert matchMedia
//         st.mmReverts?.forEach((revert) => {
//             try { revert && revert(); } catch (_) {}
//         });
//         // revert GSAP context (tue tweens + ScrollTriggers du scope)
//         st.ctx?.revert();
//         this.state.delete(block);
//     }
//
//     // ===== Layout =====
//     cardTextHeight() {
//         this.blocks.forEach((block) => {
//             const cards = block.querySelectorAll(".item-card");
//             cards.forEach((card) => {
//                 const cardText = card.querySelector(".rich-text");
//                 if (!cardText) return;
//                 // offsetHeight reste OK (padding inclus). getBoundingClientRect().height marche aussi.
//                 const h = cardText.offsetHeight;
//                 card.style.setProperty("--height", `${h}px`);
//             });
//         });
//     }
//
//     // ===== API publique appelée par ton système global =====
//     resize() {
//         this.cardTextHeight();
//     }
//
//     destroy() {
//         this.blocks.forEach((block) => this.unmountBlock(block));
//     }
// }